export default "__VITE_ASSET__BCfxxmJ3__"